;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:lang\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/contact\",\"regex\":\"^/([^/]+)/contact$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/data-deletion\",\"regex\":\"^/([^/]+)/data-deletion$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/privacy-policy\",\"regex\":\"^/([^/]+)/privacy-policy$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/help-center\",\"regex\":\"^/([^/]+)/help-center$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/seekers\",\"regex\":\"^/([^/]+)/seekers$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/gdpr\",\"regex\":\"^/([^/]+)/gdpr$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/providers\",\"regex\":\"^/([^/]+)/providers$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/cookie-policy\",\"regex\":\"^/([^/]+)/cookie-policy$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/careers\",\"regex\":\"^/([^/]+)/careers$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/security\",\"regex\":\"^/([^/]+)/security$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/community\",\"regex\":\"^/([^/]+)/community$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/about\",\"regex\":\"^/([^/]+)/about$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true},{\"path\":\"/:lang/terms-of-service\",\"regex\":\"^/([^/]+)/terms-of-service$\",\"paramNames\":[\"lang\"],\"hasOptionalPrefix\":true}],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import { sentryAuthBeforeSend } from '@bomdisoft/observability/scrubbers';
import { addIntegration, captureRouterTransitionStart, init } from '@sentry/nextjs';

init({
  beforeSend: event => sentryAuthBeforeSend(event),
  dataCollection: {
    cookies: false,
    databaseQueryData: false,
    genAI: { inputs: false, outputs: false },
    graphQL: { document: false, variables: false },
    httpBodies: [],
    httpHeaders: {
      request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    },
    queues: false,
    urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    userInfo: false,
  },
  debug: false,
  dsn: 'https://e987b154413939bd23ac6eaff2ae6dc6@o4505453294845952.ingest.us.sentry.io/4509344503365632',

  ignoreErrors: ['MetaMask extension not found', 'Failed to connect to MetaMask'],

  replaysOnErrorSampleRate: 1.0,

  replaysSessionSampleRate: 0.1,

  tracesSampleRate: 1,
});

// Replay is attached after the page goes idle rather than listed in `integrations`,
// and the import above is named rather than `* as Sentry`, because either one alone
// keeps `replayIntegration` reachable from the entry, and it drags in rrweb, ~580KB
// of source that every visitor downloads during first paint for a feature that
// samples a tenth of sessions. Sampling still decides whether anything records; this
// only decides when the recorder arrives.
const attachReplay = async () => {
  const { replayIntegration } = await import('@sentry/nextjs');
  addIntegration(replayIntegration());
};

if (typeof window !== 'undefined') {
  // requestIdleCallback is still missing on Safari before 17, so fall back to a
  // timer rather than leaving those browsers without replay entirely.
  if (typeof requestIdleCallback === 'function') requestIdleCallback(() => void attachReplay());
  else setTimeout(() => void attachReplay(), 2000);
}

export const onRouterTransitionStart = captureRouterTransitionStart;
